import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "@/features/auth/slices/authSlice";

const Logout: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Dispatch the Redux action that removes tokens from localStorage
    // and resets the auth state.
    dispatch(logout());
    // Then redirect to /login.
    navigate("/login");
  }, [dispatch, navigate]);

  // Since we immediately log out and redirect, we can render nothing, or a spinner, etc.
  return null;
};

export default Logout;
